module.exports = __webpack_public_path__ + "resources/img/bg_solution_main1_v2.e5fb81ce70913500023b07a9d543bb9d.png";